import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectIsInProgress } from '../../../features/spinner/ducks';
import { selectAccount, selectAccountBalance, fetchInvestedAmountActions, selectAccountInvestedAmount } from '../../../features/auth/ducks';
import { 
  withdrawFundsActions, 
  fetchPaymentsByAccountIdActions, 
  selectPaymentsByAccountId 
} from '../ducks';
import WithdrawFunds from '../components/WithdrawFunds';
import { apiCallIds } from '../api';
import { apiCallIds as apiCallIdsAuth } from '../../auth/api';

const mapStateToProps = state => ({
  account: selectAccount(state),
  accountBalance: selectAccountBalance(state),
  isLoading: selectIsInProgress(state, apiCallIds.WITHDRAW_FUNDS),
  payments: selectPaymentsByAccountId(state),
  investedAmount: selectAccountInvestedAmount(state),
  isLoadingPayments: selectIsInProgress(state, apiCallIds.FETCH_PAYMENTS),
  isLoadingInvestedAmount: selectIsInProgress(state, apiCallIdsAuth.FETCH_INVESTED_AMOUNT),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      withdrawFunds: withdrawFundsActions.request,
      fetchPaymentsByAccountId: fetchPaymentsByAccountIdActions.request,
      fetchInvestedAmount: fetchInvestedAmountActions.request,
    },
    dispatch
  ),
});

@connect(mapStateToProps, mapDispatchToProps)
export default class WithdrawFundsContainer extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    account: PropTypes.object.isRequired,
    accountBalance: PropTypes.number.isRequired,
    isLoading: PropTypes.bool.isRequired,
    investedAmount: PropTypes.string,
    isLoadingPayments: PropTypes.bool.isRequired,
    isLoadingInvestedAmount: PropTypes.bool.isRequired,
  };

  onWithdraw = amount => {
    this.props.actions.withdrawFunds({
      accountId: this.props.account.id,
      amount,
    });
  };

  componentDidMount() {
    this.props.actions.fetchPaymentsByAccountId({accountId: this.props.account.id});
    this.props.actions.fetchInvestedAmount({ accountId: this.props.account.id });
  }

  render() {
    const { 
      payments, 
      isLoading, 
      accountBalance, 
      isLoadingPayments, 
      investedAmount, 
      isLoadingInvestedAmount,
      account
    } = this.props;

    return (
      <WithdrawFunds
        onWithdraw={this.onWithdraw}
        isLoading={isLoading}
        accountBalance={accountBalance}
        payments={payments}
        investedAmount={investedAmount}
        isLoadingPayments={isLoadingPayments}
        isLoadingInvestedAmount={isLoadingInvestedAmount}
        role={account.role}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/payments/containers/WithdrawFundsContainer.js